// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see IntegrityCheckOnboardingEvent
 */
export var IntegrityCheckOnboarding = function (_a) {
    var trigger = _a.trigger, result = _a.result, globalConfig = _a.globalConfig, sessionToken = _a.sessionToken;
    return ({
        name: "Integrity Check Onboarding",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            global_config: globalConfig !== undefined && globalConfig !== null ? globalConfig.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_token: sessionToken !== undefined && sessionToken !== null ? sessionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckMainContentEvent
 */
export var IntegrityCheckMainContent = function (_a) {
    var trigger = _a.trigger, result = _a.result, globalConfig = _a.globalConfig, appConfig = _a.appConfig, marketCapabilities = _a.marketCapabilities, profile = _a.profile, featureEligibility = _a.featureEligibility;
    return ({
        name: "Integrity Check MainContent",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            global_config: globalConfig !== undefined && globalConfig !== null ? globalConfig.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_config: appConfig !== undefined && appConfig !== null ? appConfig.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            market_capabilities: marketCapabilities !== undefined && marketCapabilities !== null ? marketCapabilities.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile: profile !== undefined && profile !== null ? profile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            feature_eligibility: featureEligibility !== undefined && featureEligibility !== null ? featureEligibility.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckStartEvent
 */
export var IntegrityCheckStart = function (_a) {
    var trigger = _a.trigger, checks = _a.checks, abortOnAnyFailure = _a.abortOnAnyFailure;
    return ({
        name: "Integrity Check Start",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            checks: checks !== undefined && checks !== null ? checks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            abort_on_any_failure: abortOnAnyFailure !== undefined && abortOnAnyFailure !== null ? abortOnAnyFailure.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckSucceedEvent
 */
export var IntegrityCheckSucceed = function (_a) {
    var trigger = _a.trigger, optionalFailedChecks = _a.optionalFailedChecks;
    return ({
        name: "Integrity Check Succeed",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            optional_failed_checks: optionalFailedChecks !== undefined && optionalFailedChecks !== null ? optionalFailedChecks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckRefreshDataEvent
 */
export var IntegrityCheckRefreshData = function (_a) {
    var trigger = _a.trigger, checks = _a.checks;
    return ({
        name: "Integrity Check RefreshData",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            checks: checks !== undefined && checks !== null ? checks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckRetryEvent
 */
export var IntegrityCheckRetry = function (_a) {
    var trigger = _a.trigger, checks = _a.checks;
    return ({
        name: "Integrity Check Retry",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            checks: checks !== undefined && checks !== null ? checks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see IntegrityCheckFailEvent
 */
export var IntegrityCheckFail = function (_a) {
    var trigger = _a.trigger, mandatoryFailedChecks = _a.mandatoryFailedChecks, optionalFailedChecks = _a.optionalFailedChecks;
    return ({
        name: "Integrity Check Fail",
        parameters: {
            cdf_entity: "Integrity",
            cdf_action: "Check",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            mandatory_failed_checks: mandatoryFailedChecks !== undefined && mandatoryFailedChecks !== null ? mandatoryFailedChecks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            optional_failed_checks: optionalFailedChecks !== undefined && optionalFailedChecks !== null ? optionalFailedChecks.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
